import { render, staticRenderFns } from "./sendmoney-contribution-table.vue?vue&type=template&id=ec49eba0&"
import script from "./sendmoney-contribution-table.vue?vue&type=script&lang=js&"
export * from "./sendmoney-contribution-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports